import React, { useState, useCallback, Fragment } from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import { FormattedMessage } from 'react-intl';

import { PdpSharedDescriptionContent } from './PdpSharedDescriptionContent';
import { PdpSharedContactDealerButton } from '../PdpSharedButtons/PdpSharedContactDealerButton';
import classNames from 'classnames';
import styles from './PdpSharedDescription.scss';

const COLLAPSED_CONTENT_HEIGHT = 120;

export const Title = () => (
    <FormattedMessage
        id="PdpSharedDescriptionAdditionalOptions.customizationHeader"
        defaultMessage="Additional Options"
    />
);
const PdpSharedDescriptionAdditionalOptionsContentComponent = ({
    customizationOptions,
    contentClass,
    buttonClass,
    item,
    user,
    isFullWidthCta = false,
}) => {
    const [contentHeight, setContentHeight] = useState(null);
    const setContentRef = useCallback(node => {
        if (node) {
            setContentHeight(node.getBoundingClientRect().height);
        }
    }, []);

    const shouldBeExpandable = contentHeight >= COLLAPSED_CONTENT_HEIGHT;

    const content = (
        <Fragment>
            <span className={classNames(styles.content, contentClass)} ref={setContentRef}>
                {customizationOptions}
            </span>
            <div className={styles.ctaWrapper}>
                <PdpSharedContactDealerButton
                    size="small"
                    fullWidth={isFullWidthCta}
                    buttonType="secondary"
                    type={'REQUEST_CUSTOMIZATION'}
                    item={item}
                    user={user}
                />
            </div>
        </Fragment>
    );

    return shouldBeExpandable ? (
        <PdpSharedDescriptionContent
            collapsedHeight={COLLAPSED_CONTENT_HEIGHT}
            buttonClass={classNames(styles.button, buttonClass)}
        >
            {content}
        </PdpSharedDescriptionContent>
    ) : (
        content
    );
};

PdpSharedDescriptionAdditionalOptionsContentComponent.propTypes = {
    customizationOptions: PropTypes.string,
    contentClass: PropTypes.string,
    buttonClass: PropTypes.string,
    item: PropTypes.object,
    user: PropTypes.object,
    isFullWidthCta: PropTypes.bool,
};

export const PdpSharedDescriptionAdditionalOptionsContent = createFragmentContainer(
    PdpSharedDescriptionAdditionalOptionsContentComponent,
    {
        user: graphql`
            fragment PdpSharedDescriptionAdditionalOptionsContent_user on User {
                ...PdpSharedContactDealerButton_user
            }
        `,
        item: graphql`
            fragment PdpSharedDescriptionAdditionalOptionsContent_item on Item {
                ...PdpSharedContactDealerButton_item
            }
        `,
    }
);
